import { numberWithCommas } from "../helpers/app/numberFormater";
import {
  drawApprovalTable,
  drawDetailsTable,
  drawExpensesTable,
  drawFormHeader,
  formatPdfDate,
  renderSinglePageForm,
} from "../helpers/app/formPdf";

const generateRequisitionMemoPdf = (data, currency) => {
  const money = (amount) =>
    `${currency === "D" ? "USD" : "UGX"} ${numberWithCommas(amount)}`;

  const doc = renderSinglePageForm((doc, layout) => {
    let y = drawFormHeader(doc, "AMANI INITIATIVE REQUISITION FORM", layout);

    y = drawDetailsTable(
      doc,
      [
        ["Date:", formatPdfDate(data.created_at)],
        ["Requisition Form Number:", data.memo_number],
        ["Project:", data.projectDetails?.name],
        ["Source of Funds:", data.donorDetails?.name],
        ["Budget Line:", data.budgetLineDetails?.name],
        ["Budget Code:", data.budgetLineDetails?.expense_code],
        ["Type:", data.type],
        ["Details:", data.details],
      ],
      y,
      layout
    );

    let total = 0;
    const rows = (data.requisitionMemoActivities || []).map((activity) => {
      total += activity.total_cost;
      return [
        activity.activityName,
        numberWithCommas(activity.units),
        money(activity.unit_cost),
        money(activity.total_cost),
      ];
    });
    y = drawExpensesTable(
      doc,
      "Requisition Memo Expenses",
      ["Expense Item", "Units", "Unit Cost", "Total Amount"],
      rows,
      ["Total", "", "", money(total)],
      y,
      layout
    );

    y = drawApprovalTable(
      doc,
      [
        { label: "Prepared", person: data?.creator, date: data.created_at },
        { label: "Checked", person: data?.checker, date: data.checked_at },
        { label: "Approved", person: data?.approver, date: data.approved_at },
      ],
      y,
      layout
    );

    return y;
  });
  doc.save(
    `AMANI INITIATIVE REQUISITION FORM ${data.memo_number || ""}`.trim()
  );
};

export default generateRequisitionMemoPdf;
